import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

const MediaSkeleton = () => (
  <Box display="grid" gridTemplateColumns="1fr 1fr" mt={3} gap={3}>
    {Array.from(new Array(4)).map((_, index) => (
      /* eslint-disable react/no-array-index-key */
      <Skeleton key={`skeleton-${index}`} variant="rounded" width="100%" height="300px" />
    ))}
  </Box>
);

export default MediaSkeleton;
